import './index.css';
import './styles/Card.css'
import './styles/Grid.css'
import './styles/Utility.css'
import '@syncfusion/ej2/material3.css';
import ReactDOM from "react-dom/client";
import { BrowserRouter as Router } from "react-router-dom";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "./styles/theme";
import App from "./App";

import { store } from './app/store';
import { Provider } from 'react-redux';

import {PublicClientApplication, EventType,EventMessage, AuthenticationResult} from "@azure/msal-browser";
import { msalConfig } from "./utils/authConfig";

import { registerLicense } from '@syncfusion/ej2-base';

registerLicense('Ngo9BigBOggjHTQxAR8/V1JEaF5cXmRCf1FpRmJGdld5fUVHYVZUTXxaS00DNHVRdkdmWXlcd3ZURmhfVU1zXEZWYEk=');

export const msalInstance = new PublicClientApplication(msalConfig);

msalInstance.initialize().then(() => {
    // Account selection logic is app dependent. Adjust as needed for different use cases.
    const accounts = msalInstance.getAllAccounts();
    if (accounts.length > 0) {
        msalInstance.setActiveAccount(accounts[0]);
    }

    msalInstance.addEventCallback((event: EventMessage) => {
        if (event.eventType === EventType.LOGIN_SUCCESS && event.payload) {
            const payload = event.payload as AuthenticationResult;
            const account = payload.account;
            msalInstance.setActiveAccount(account);
        }
    });

    const root = ReactDOM.createRoot(
        document.getElementById("root") as HTMLElement
    );
    root.render(
        <Provider store={store}>
            <Router>
                <ThemeProvider theme={theme}>
                    <App pca={msalInstance} />
                </ThemeProvider>
            </Router>
        </Provider>
    );
});
